import {LayoutSize} from '../../../../../enums/layout-size.enum';

export namespace SidebarDrawer {
    export enum Direction {
        left = 'left',
        right = 'right',
    }

    export interface PositionConfigItem {
        backdrop?: boolean;
        direction: Direction;
        fullwidth?: boolean;
        padded?: boolean;
    }

    export type PositionConfig = {[layout in keyof typeof LayoutSize]?: PositionConfigItem};
}
